module.exports = __webpack_public_path__ + "img/ring_y_o_1_0@2x.bbd9631e.png";